'use strict';

const pageDesignerUtils = require('../util/pageDesigner');
const recurringPurchase = require('./recurringPurchase');
/**
 * This function sets up the AJAX request to update the user session.
 * If the update fails, the popup is shown again.
 *
 * @function
 * @requires jQuery
 * @param {jQuery} e event variable
 */
function hidePopin () {
    var $button = $('.delivery-address-tooltip .tooltip-close')
    var $popin = $button.closest('.delivery-address-tooltip');
    var url = $button.data('url');
    $popin.hide();

    $.ajax({
        url: url,
        method: 'POST',
        success: function(data) {
            if (!data.success) {
                $popin.show();
            }
        }
    });
}

/**
 * This function opens the delivery method modal
 * @function
 * @requires jQuery
 */
function openDeliveryModal () {
    $(document).trigger("openDeliveryModalRequest", { redirectUrl: '' });
}

/**
 * @function
 * @requires jQuery
 * @param {Object} target Click target
 * @returns {boolean} result
 */
function shouldOpenModal(target) {
    return !(target.hasClass('tooltip-close') || target.hasClass('keep-delivery'));
}


/**
 * Sends the selected delivery address information to the server via AJAX and reloads the page on success.
 *
 * @param {Object} fulfillmentInfo - The fulfillment information containing address details.
 * @param {string} url - The endpoint URL to send the delivery information to.
 * @param {boolean} isDelivery - Indicates if user wants to keep delivery address or locker/store address.
 */
function handleKeepSelection(fulfillmentInfo, url, isDelivery) {
    var payload;
    if (isDelivery) {
        payload = $.extend({
            latitude: fulfillmentInfo.address.location.latitude,
            longitude: fulfillmentInfo.address.location.longitude,
            addressDetails: fulfillmentInfo.address.details,
            addressName: fulfillmentInfo.address.name,
            zipCode: fulfillmentInfo.address.location.zipCode,
            stateCode: fulfillmentInfo.address.location.stateCode
        }, recurringPurchase.getRecurringPurchaseState());
    } else {
        payload = {
            storeID: fulfillmentInfo.address.storeId,
            addressDetails: fulfillmentInfo.address.details,
            addressName: fulfillmentInfo.address.name
        };
    }

    if (!payload) {
        return;
    }

    $.ajax({
        url: url,
        method: 'POST',
        data: payload,
        dataType: 'json',
        success: function() {
            // Reload the page to reflect the changes
            window.location.reload();
        },
        error: function(xhr, status, error) {
            console.error('Error on SetDelivery request:', error);
        }
    });
}

/**
 * This function sets up the popin click event
 *
 * @function
 * @requires jQuery
 * @param {jQuery} e event variable
 */
function handlePopinClick (e) {
    e.preventDefault();

    hidePopin();

    // if event target is NOT the close button, opens the delivery modal
    if (shouldOpenModal($(e.target))) {
        openDeliveryModal();
    } else {
        var fulfillmentInfo = $('.delivery-address-tooltip').data('fulfillment-info');
        if (!fulfillmentInfo) {
            return;
        };

        if (fulfillmentInfo.isShippingMethodDelivery) {
            var setDeliveryURL = $('.delivery-address-tooltip').data('keep-delivery-url');
            if (!setDeliveryURL) {
                return;
            };

            handleKeepSelection(fulfillmentInfo, setDeliveryURL, true);
        }

        if (fulfillmentInfo.isShippingMethodLocker) {
            var setLockerURL = $('.delivery-address-tooltip').data('keep-locker-url');
            if (!setLockerURL) {
                return;
            };

            handleKeepSelection(fulfillmentInfo, setLockerURL, false);
        }
    }
}

/**
 * Initializes the delivery method handler functionality.
 * @function
 * @requires jQuery
 */
function initDeliveryMethodPopin () {
    if (pageDesignerUtils.isPageDesignerEditMode()) {
        $('.delivery-address-tooltip').hide();
    } else {
        $('.delivery-address-tooltip').on('click', handlePopinClick);
    }
}

module.exports = {
    initDeliveryMethodPopin: initDeliveryMethodPopin
};
